
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: "DBDACD",
components: {
XTable,
},
};



// WEBPACK FOOTER //
// ./src/pages/formulas/Common/DBDACD.vue